import { render, staticRenderFns } from "./EvaluationsOfTheYear.vue?vue&type=template&id=49caa786"
import script from "./EvaluationsOfTheYear.vue?vue&type=script&lang=js"
export * from "./EvaluationsOfTheYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports